import { Box, Flex, useToast } from '@chakra-ui/react'
import DsrPageSideMenu from './DsrPageSideMenu'
import DisplayNewsFeed from '../dsr-content-components/DisplayNewsFeed'

import DsrConfirmationModal from './DsrConfirmationModal'
import { memo, useState, useEffect, useRef } from 'react'
import { createNewPostReply, updateDsrPost } from '../helpers/dsr-helpers'
import { withRouter, useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  createNewDsrFeedPost,
  createNewDsrFeedReply,
  deleteDsrFeedPost,
  deleteDsrReply,
  editDsrFeedPost,
  editDsrReaction,
  editDsrReply,
  loadMoreFeedContentAct,
  replaceDsrFeedContent,
} from '../actions/dsr-actions'
import { logGuestDsrAnalytics } from '../../analytics/actions/dsr-analytics-actions'
import { bindActionCreators } from 'redux'
import RenderSubpageContent from './RenderSubpageContent'
import '../../layout/components/layout/styles/dsr-content.scss'
import DsrDynamicModal from '../messages/DsrDynamicModal'
import { sendToGA } from '../../global/helpers/google-tag-helpers'
import { getThisUserIdToken, triggerLaunchdeckToast } from '../../global/helpers/global-helpers'
import EngagementTimer from '../../global/components/timer/EngagementTimer'
import EmbeddedZoomMeetingDisplay from '../dsr-zoom/EmbeddedZoomMeetingDisplay'
import useLaunchdeckModal from '../../global/hooks/use-launchdeck-modal'
import { manageDsrUrlTags } from '../../global/helpers/url-tag-helpers'
import useChangeSubpageDisplay from '../../global/hooks/change-subpage-display'

// Note: Render Dsr Content for ACTIVE states
const RenderDsrContent = ({
  dsrFeedContent,
  dsrId,
  dsrConfiguration,
  dsrUserTeam,
  sessionId,
  userProfile,
  dsrActionList,
  selectedDisplaySubpage, // TODO Review: required for MAP page however.
  selectedDisplayPageId,
  editDsrReaction,
  editDsrFeedPost,
  deleteDsrFeedPost,
  deleteDsrReply,
  createNewDsrFeedPost,
  createNewDsrFeedReply,
  editDsrReply,
  logGuestDsrAnalytics,
  userActionRequiredState,
  showDsrModalState,
  showLoadMoreRedux,
  loadMoreFeedContentAct,
  dsrPagesRedux,
  replaceDsrFeedContent,
  dsrPropertiesRedux,
  dsrTeamMembersRedux,
  createNewDsrFeedPostOutcome,
  editDsrFeedPostOutcome,
  editDsrFeedReplyOutcome,
  headerMenuHeight,
  isReadingMode,
  sideMenuOffsetRequired,
  isMobileView,
  isSellingTeamMember,
  overviewPageId
}) => {
  const { pageIdToken } = useParams();
  const initialPageRef = useRef(false);
  const activeSecondsRef = useRef(0);
  const { handleSelectSubpage, clickCount } = useChangeSubpageDisplay();

  // Reset function
  const resetEngagementTimer = () => {
    activeSecondsRef.current = 0;
  };

  const { openLaunchdeckModal, closeLaunchdeckModal } = useLaunchdeckModal();

  const [localState, setLocalState] = useState({
    showDsrModalLoader: false,
    showConfirmationModal: false,
    confirmationType: '',
    postContentToEdit: '',
    replyIdToEdit: '',
    userIdToken: '',
    modalTransferPayload: '',
    postTagProperties: [],
  })

  const toast = useToast();
  const [showPostUploadImageOption, setShowPostUploadImageOption] = useState(false)
  const isGuestUser = (dsrUserTeam === "audience") ? true : false;

  const [extraHeaderLayoutOffset, setExtraHeaderLayoutOffset] = useState(false)

  useEffect(() => {
    if (dsrPropertiesRedux.logoDisplayOption) {
      if (dsrPropertiesRedux.logoDisplayOption === "default") {
        !!extraHeaderLayoutOffset && setExtraHeaderLayoutOffset(false)
      } else {
        !extraHeaderLayoutOffset && setExtraHeaderLayoutOffset(true)
      }
		}
	}, [dsrPropertiesRedux.logoDisplayOption]);

  useEffect(() => {
    if (editDsrFeedPostOutcome) {
      if(editDsrFeedPostOutcome.updateAction==="flag-reported-post") {
        toast(
          triggerLaunchdeckToast({
            useCase: "show-success-state",
            bannerText:"Success",
            label: "Your post has been flagged for Room Administrators to act on. In the meantime, it'll be hidden to you.",
            isMobileView
          })
        )
      }
      closeLaunchdeckModal()
    } else 
    if (createNewDsrFeedPostOutcome || editDsrFeedReplyOutcome) {
      closeLaunchdeckModal()
    }
  }, [createNewDsrFeedPostOutcome, editDsrFeedPostOutcome, editDsrFeedReplyOutcome]);

  useEffect(() => {
      const handleUrlChange = () => {  
        const viewpage = manageDsrUrlTags("viewpage");
        
        switch(viewpage) {
          case('overview'): {
            // Overview page is called with pageId
            overviewPageId && handleClickSubpageChange(overviewPageId, "")
            break;
          }
          case('updates'): {
            handleClickSubpageChange("","updates-subpage")
            break;
          }
          case('faq'): {
            handleClickSubpageChange("","faq-subpage")
            break;
          }
          case('map'): {
            handleClickSubpageChange("","action-list-subpage")
            break;
          }
          case('shared-docs'): {
            handleClickSubpageChange("","shared-docs-folder-subpage")
            break;
          }
          default: {
            viewpage && handleClickSubpageChange("pg__" + viewpage,"")
            break;
          }
        }
      };
      
      window.addEventListener("url-changed", handleUrlChange);

      return () => {
        window.removeEventListener("url-changed", handleUrlChange);
      };
    
    }, [dsrPagesRedux]);


  const refreshData = (dataType, newDataSet) => {
    //Used by child components to update data in this parent component, after specific actions are taken
    if ( dataType === 'updated-news-feed-content') {
      setLocalState((prevState) => ({
        ...prevState,
        showDsrModalLoader: false,
      }))

      replaceDsrFeedContent(newDataSet)
    }
  }

  // Page view management
  const handleClickSubpageChange = (newSelectedDisplayPageId, newSelectedDisplayFixedSubpageType) => {
    handleSelectSubpage(newSelectedDisplayPageId, newSelectedDisplayFixedSubpageType)

    if (isGuestUser) {
      // For Sales intelligence
      logGuestDsrAnalytics({
        eventType: 'guest-views-subpage',
        analyticsPayload: {
          userId: getThisUserIdToken(),
          dsrId,
          sessionId: sessionId,
          engagementDurationSeconds: activeSecondsRef.current,
          viewedPageId: selectedDisplayPageId ? selectedDisplayPageId : selectedDisplaySubpage,
        }
      })

      resetEngagementTimer()
    }

    // For internal BI
    sendToGA('view_dsr_page', {
      'eventTimestamp': new Date().toISOString(),
      'dsrId': dsrId,
      'userIdToken': getThisUserIdToken(),
      'pageId': selectedDisplayPageId ? selectedDisplayPageId : selectedDisplaySubpage,
      'pageEngagementTimeSeconds': activeSecondsRef.current
    });
}

  useEffect(() => {
    // TODO Note: For route management. Align this with url tag method in the future
    if (pageIdToken) {
      if (pageIdToken === "updates") {
        handleClickSubpageChange("",'updates-subpage')
      } else if (pageIdToken === "shared-docs") {

        handleClickSubpageChange("",'shared-docs-folder-subpage')
      } else if (pageIdToken === "map") {
        handleClickSubpageChange("",'action-list-subpage')
      } else {
        const pageId = 'pg__' + pageIdToken;
        handleClickSubpageChange(pageId,"")
      }

    }
    else if (!pageIdToken && !initialPageRef.current) {
      // Default page for the first time when page is loaded
      const overviewPageId = dsrPagesRedux ? dsrPagesRedux[0].pageId : "";

      if (overviewPageId) {
        handleClickSubpageChange(overviewPageId, "")
        initialPageRef.current = true
      }

    }
  }, [pageIdToken, dsrPagesRedux]);

  // Analytics 
  useEffect(() => {
    // Register the duration in which the last subpage was viewed before user closes the window or exits the DSR
    const handleBeforeUnload = () => {

      logGuestDsrAnalytics({
        eventType: 'guest-views-subpage',
        analyticsPayload: {
          userId: getThisUserIdToken(),
          dsrId,
          sessionId: sessionId,
          engagementDurationSeconds: activeSecondsRef.current,
          viewedPageId: selectedDisplayPageId
        }
      })
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [logGuestDsrAnalytics, dsrId, sessionId, selectedDisplayPageId])

  // UX Handlers
  const handleSetShowDsrModalLoader = () => {
    setLocalState((prevState) => ({
      ...prevState,
      showDsrModalLoader: true,
    }))
  }

  const handleStopDsrModalLoader = () => {
    setLocalState((prevState) => ({
      ...prevState,
      showDsrModalLoader: false,
    }))
  }

  const handleAddRemoveMessageReaction = (reactionProps) => {
    const updatePostReactionPayload = {
      postReactionPayload: reactionProps,
      dsrId: dsrId,
    }

    editDsrReaction(updatePostReactionPayload)
  }

  const handleConfirmationModalOpen = (payload, confirmationType) => {
    const { postId, replyId } = payload

    setLocalState((prevState) => ({
      ...prevState,
      showConfirmationModal: true,
      confirmationType,
      postIdToEdit: postId,
      replyIdToEdit: replyId,
    }))
  }

  const handleConfirmationModalClose = () => {
    setLocalState((prevState) => ({
      ...prevState,
      showConfirmationModal: false,
      confirmationType: '',
      postIdToEdit: '',
      modalTransferPayload: '',
    }))
  }

  const handleChangeUserActionRequired = (newUserActionRequired, modalTransferPayload) => {
    openLaunchdeckModal(newUserActionRequired)
    
    // TODO: Remove this gradually to use openLaunchdeckModal custom hook payload tranfer mechanism
    setLocalState((prevState) => ({
      ...prevState,
      modalTransferPayload,
    }))
  }


  const handleDsrModalClose = () => {
    closeLaunchdeckModal()

    setLocalState((prevState) => ({
      ...prevState,
      postIdToEdit: '',
    }))
  }

  const handleReportPost = (reportedPostId, reportMetaData) => {
    handleSetShowDsrModalLoader()

    let foundIndex = dsrFeedContent.findIndex((msg) => {
      return msg.postId === reportedPostId
    })

    if (foundIndex === -1) {  // <-- Altered: Added check for when the post is not found
      console.error("Post not found with id:", reportedPostId);  // <-- Altered: Log error message
      return; // Or handle this case appropriately
    }

    let reportedPost = dsrFeedContent[foundIndex]
    const {flaggedPostReports} = reportedPost || {}
    const {reportReason, reportReasonNotes} = reportMetaData || {}
    const newFlaggedPostReport = {
      reportUserId:getThisUserIdToken(),
      dateReported: new Date().toISOString(),
      reportReason: reportReasonNotes ? `${reportReason}: ${reportReasonNotes}` : reportReason,
      adminDecision:"",
      decisionDate:"",
      adminUserId:""
    }

    const updatedFlaggedPostReports = flaggedPostReports ? [...flaggedPostReports, newFlaggedPostReport] : [newFlaggedPostReport]

    const updatedPost = {
      ...reportedPost,
      flaggedPostReports: updatedFlaggedPostReports
    }

    const newDataSet = dsrFeedContent.map((post, index) => {
      return index === foundIndex ? updatedPost : post
    })
    replaceDsrFeedContent(newDataSet)

    const editedPostPayload = {
      actionRequired: 'flag-reported-post',
      dsrId: dsrId,
      updatedPost,
    }
    editDsrFeedPost(editedPostPayload)
  }

  const handleReportReply = (reportedPostId, reportedReplyId, reportMetaData) => {
    // handleSetShowDsrModalLoader()

    let foundIndex = dsrFeedContent.findIndex((msg) => {
      return msg.postId === reportedPostId
    })

    if (foundIndex === -1) {  // <-- Altered: Added check for when the post is not found
      console.error("Post not found with id:", reportedPostId);  // <-- Altered: Log error message
      return; // Or handle this case appropriately
    }

    let postToUpdate = dsrFeedContent && dsrFeedContent[foundIndex]

    let { postReplies } = postToUpdate || {}
    let foundReplyIndex = postReplies.findIndex(
      (reply) => reply.replyId === reportedReplyId,
    )
    let reportedReply = postReplies && foundReplyIndex >= 0 ? postReplies[foundReplyIndex] : {}

    const {flaggedReplyReports} = reportedReply || {}
    const {reportReason, reportReasonNotes} = reportMetaData || {}

    const newFlaggedReplyReport = {
      reportUserId:getThisUserIdToken(),
      dateReported: new Date().toISOString(),
      reportReason: reportReasonNotes ? `${reportReason}: ${reportReasonNotes}` : reportReason,
      adminDecision:"",
      decisionDate:"",
      adminUserId:""
    }

    const updatedFlaggedReplyReports = flaggedReplyReports ? [...flaggedReplyReports, newFlaggedReplyReport] : [newFlaggedReplyReport]

    const updatedReply = {
      ...reportedReply,
      flaggedReplyReports: updatedFlaggedReplyReports
    }

    postReplies[foundReplyIndex] = updatedReply

      const updatedPost = {
        ...postToUpdate,
        updatedReply
      }

      const newDataSet = dsrFeedContent.map((post, index) =>
        index === foundIndex ? updatedPost : post,
      )
      replaceDsrFeedContent(newDataSet)


  // Send to DB to save the edited reply
  const editedReplyPayload = {
    dsrId: dsrId,
    postIdToEdit: reportedPostId,
    replyIdToEdit: reportedReplyId,
    actionRequired: 'flag-reported-reply',
    updatedReply: updatedReply,
  }

  editDsrReply(editedReplyPayload)

  }

  const handleUpdatePostContent = (updatedContent) => {
    handleSetShowDsrModalLoader()
    
    const { postContent, postIdToEdit, replaceImage, files } = updatedContent || {}
    
    let foundIndex = dsrFeedContent.findIndex((msg) => {
      return msg.postId === postIdToEdit
    })

    let postToUpdate = dsrFeedContent[foundIndex]
    const changesToContent = (postToUpdate?.postContent.trim() !== postContent.trim()) || !!replaceImage

    if (changesToContent) {
      const updatedPost = {
        ...postToUpdate,
        postContent,
        editedMessageAt: new Date().toISOString(),
      }

      // Saving it to BE
      const editedPostPayload = {
        actionRequired: "update-content",
        dsrId: dsrId,
        updatedPost,
        replaceImageRequired: replaceImage,
        files: files || null
      }

      editDsrFeedPost(editedPostPayload)
    } else {
      // No update required if string value is the same (i.e. not edits/changes). Just close the modal.
      closeLaunchdeckModal()
    }
  }

  const handleCreateNewPostReply = ({ replyContent, postId }) => {
    const { userId, userName, memberProfilePicSrc } = userProfile || {}

    const newReplyMetadata = {
      currentPostArray: dsrFeedContent,
      postId: postId,
      replyContent,
      userIdToken: userId, // TODO: Change the userIdToken field to userId only
      userName,
      memberProfilePicSrc,
    }
    
    // Updated in state to provide real-time UX display
    createNewPostReply({ ...newReplyMetadata, replaceDsrFeedContentAction: replaceDsrFeedContent })
    closeLaunchdeckModal()

    // Update in backend DB
    const newDsrFeedReplyMetadata = {
      dsrId: dsrId,
      postId: postId,
      replyContent,
      // replyType
    }

    createNewDsrFeedReply(newDsrFeedReplyMetadata)
  }

  const handleEditPostReply = (updatedContent) => {
    handleSetShowDsrModalLoader()

    const { replyContent, postIdToEdit, replyIdToEdit } = updatedContent || {}

    let foundIndex = dsrFeedContent.findIndex(
      (msg) => msg.postId === postIdToEdit,
    )

    let postToUpdate = dsrFeedContent && dsrFeedContent[foundIndex]
    let { postReplies } = postToUpdate || {}
    let foundReplyIndex = postReplies.findIndex(
      (reply) => reply.replyId === replyIdToEdit,
    )
    let replyToUpdate = postReplies && foundReplyIndex >= 0 ? postReplies[foundReplyIndex] : {}


    // Compare string values & update only values are different
    if (replyToUpdate.replyContent.trim() !== updatedContent.replyContent.trim()) {
      // Organise the reply
      const updatedReply = {
        ...replyToUpdate,
        replyContent,
        editedReplyAt: new Date().toISOString(),
      }

      postReplies[foundReplyIndex] = updatedReply

      const updatedPost = {
        ...postToUpdate,
        updatedReply
      }

      const newDataSet = dsrFeedContent.map((post, index) =>
        index === foundIndex ? updatedPost : post,
      )
      replaceDsrFeedContent(newDataSet)

      if (updatedContent.replyContent.trim() === '') {
        console.log('Throw error and inform user about empty field')
      } else {
        // Send to DB to save the edited reply
        const editedReplyPayload = {
          dsrId: dsrId,
          postIdToEdit: postIdToEdit,
          replyIdToEdit: replyIdToEdit,
          updatedReply: updatedReply,
        }

        editDsrReply(editedReplyPayload)
      }
    } else {
      // No update. Just close the modal.
      closeLaunchdeckModal()
    }
  }

  const handleOpenNewPostModal = (userActionRequired, payload) => {
    const { setShowUploadImage } = payload || {}
    
    openLaunchdeckModal(userActionRequired, {dsrId: dsrId})
    setShowPostUploadImageOption(setShowUploadImage ? setShowUploadImage : false)
  }

  const handleDeleteMessagePost = (postId) => {
    if (!postId) {
      console.log('There is no postId')
    } else {
      const updateDsrMessageFields = {
        dsrMessageContentArray: dsrFeedContent,
        operation: 'update-message-status',
        postId,
        fieldsToUpdate: {
          postStatus: 'deleted',
          postDeletedAt: new Date(),
        },
      }

      // Updated in state to provide real-time UX display
      updateDsrPost({
        ...updateDsrMessageFields,
        replaceDsrFeedContentAction: replaceDsrFeedContent,
      })

      // Update in backend DB
      const deletePostPayload = {
        dsrId: dsrId,
        postId,
      }

      deleteDsrFeedPost(deletePostPayload)
    }

    // Close & reset temp UX control parameters
    handleConfirmationModalClose()

    // LATER improvement scope: return value to display general error using outcome redux
  }

  const handleDeleteReply = ({ postIdToEdit, replyIdToEdit }) => {
    const updateDsrMessageFields = {
      dsrMessageContentArray: dsrFeedContent,
      operation: 'update-deleted-reply-status',
      postId: postIdToEdit,
      replyId: replyIdToEdit,
    }
    updateDsrPost({ ...updateDsrMessageFields, replaceDsrFeedContentAction: replaceDsrFeedContent })


    // Manage UX without re-loading the page

    // Write the new soft deleted status into DB
    const deleteReplyPayload = {
      dsrId: dsrId,
      postIdToEdit,
      replyIdToEdit,
    }

    deleteDsrReply(deleteReplyPayload)

    // Close & reset temp UX control parameters
    handleConfirmationModalClose()
  }

  const handleCreateNewPost = ({ userActionRequired, inputValue, files, postType, loomVideo, userTagProperties, tempUxPostId }) => {
    switch (userActionRequired) {
      case 'create-new-post': {
        handleSetShowDsrModalLoader()
        const instructions = {
          tempUxPostId,
          ...(files && {containsImages: true})
        }
        createNewDsrFeedPost({
          dsrId,
          postType: postType ? postType : 'short-text',
          postContent: inputValue,
          files,
          userTagProperties
        }, instructions)
        break
      }
      case 'create-video-post': {
        handleSetShowDsrModalLoader()

        createNewDsrFeedPost({
          dsrId,
          postType: postType,
          postContent: inputValue,
          loomVideo,
          userTagProperties
        }, {tempUxPostId})
        break
      }
      case 'create-faq-question': {
        handleSetShowDsrModalLoader()

        createNewDsrFeedPost({
          dsrId,
          postType: 'faq-question-post',
          postContent: inputValue,
        }, {tempUxPostId})
        break
      }
      default: {
        console.log('Cannot create new post when handling this type of action:', userActionRequired)
        break
      }
    }
  }

  const loadMoreFeedContent = () => {
    loadMoreFeedContentAct(dsrId)
  }

  return (
    <Flex justifyContent={['flex-start', 'center']} className="dsr-content__section">
      {/* // Engagement Time is meant to be hidden and has no displayed UI */}
      {isGuestUser &&
        <EngagementTimer
          updateActiveSecondsRef={activeSecondsRef} 
          resetTimer={resetEngagementTimer}
        />
      }
      <Flex className="dsr-content__container">
        <Flex direction="column" align="flex-start" w="100%" height="100%">
          <Flex direction="row" align="flex-start" width="100%">
            <Flex display={['none', 'flex']} position='sticky' top={headerMenuHeight} bg="white">
              <DsrPageSideMenu
                pageArray={dsrPagesRedux}
                selectedDisplayPageId={selectedDisplayPageId}
                handleSelectSubpage={handleClickSubpageChange}
                headerMenuHeight={headerMenuHeight}
                sideMenuOffsetRequired={sideMenuOffsetRequired}
                dsrProperties={dsrPropertiesRedux}
                altPageNames={dsrPropertiesRedux.altPageNames}
                extraHeaderLayoutOffset={extraHeaderLayoutOffset}
                isSellingTeamMember={isSellingTeamMember}
              />
            </Flex>
            <Flex
              direction={['column', 'column', 'column', 'row']}
              justify="center"
              flexWrap="wrap"
              width="100%"
              background="#F4F4F4"
              h='auto'
              minH='100vh'
            >
              <Box 
                key={'page-view-' +clickCount}
                className="dsr-content__middle-column-container fade-in"
                transition="max-width 0.75s ease-in-out"
                pt={extraHeaderLayoutOffset && '1em'}
                maxWidth={isReadingMode ? '1200px' : ['100%', '800px']} 
                px={isMobileView ? "0em" : isReadingMode ? "5em" : "1em"} 
                w='100%'
              >
                
                {selectedDisplaySubpage === 'updates-subpage' &&
                  <DisplayNewsFeed
                    dsrId={dsrId}
                    dsrTitle={dsrConfiguration?.dsrTitle}
                    userIdToken={localState.userIdToken}
                    displayedPostContent={dsrFeedContent}
                    loadMoreFeedContent={loadMoreFeedContent}
                    loadingMoreContent={dsrFeedContent?.isLoading || false}
                    showLoadMore={showLoadMoreRedux}
                    userProfile={userProfile}
                    dsrTeamMembers={dsrConfiguration?.dsrTeamMembers}
                    handleCreateNewPost={handleCreateNewPost}
                    handleAddRemoveMessageReaction={handleAddRemoveMessageReaction}
                    onClickDeleteMessageOption={handleConfirmationModalOpen}
                    onClickDeleteReplyOption={handleConfirmationModalOpen} // Refactor possible?
                    handleCreateNewPostReply={handleCreateNewPostReply}
                    handleOpenNewPostModal={handleOpenNewPostModal}
                    refreshData={refreshData}
                    handleSelectSubpage={handleClickSubpageChange}
                    handleStopDsrModalLoader={handleStopDsrModalLoader}
                    handleChangeUserActionRequired={handleChangeUserActionRequired}
                  />
                }

                <RenderSubpageContent
                  pageArray={dsrPagesRedux}
                  selectedDisplaySubpage={selectedDisplaySubpage}
                  selectedDisplayPageId={selectedDisplayPageId}
                  dsrTeamMembers={dsrTeamMembersRedux}
                  dsrId={dsrId}
                  dsrActionList={dsrActionList}
                  dsrProperties={dsrPropertiesRedux}
                  handleSelectSubpage={handleClickSubpageChange}
                  handleChangeUserActionRequired={handleChangeUserActionRequired}
                  isMobileView={isMobileView}
                />
                <EmbeddedZoomMeetingDisplay />
              </Box>
            </Flex>

            {/* // This section houses dynamically rendered components that depends on user journey */}
            {localState.showConfirmationModal && localState.confirmationType && (
              <DsrConfirmationModal
                // Logics
                postIdToEdit={localState.postIdToEdit}
                replyIdToEdit={localState.replyIdToEdit}
                confirmationType={localState.confirmationType} // Get from state to make this dynamic
                isMobileView={isMobileView}
                // Function
                handleCloseConfirmationModal={handleConfirmationModalClose}
                handleDeleteMessagePost={handleDeleteMessagePost}
                handleDeleteReply={handleDeleteReply}
              />
            )}

            <DsrDynamicModal
              dsrId={dsrId}
              userActionRequired={userActionRequiredState}
              showDsrModal={showDsrModalState}
              showDsrModalLoader={localState.showDsrModalLoader}
              handleDsrModalClose={handleDsrModalClose}
              postTagProperties={localState.postTagProperties}
              handleUpdatePostContent={handleUpdatePostContent}
              handleEditPostReply={handleEditPostReply}
              handleCreateNewPost={handleCreateNewPost}
              handleChangeUserActionRequired={handleChangeUserActionRequired}
              modalTransferPayload={localState.modalTransferPayload}
              editDsrFeedReplyOutcome={editDsrFeedReplyOutcome}
              showPostUploadImageOption={showPostUploadImageOption}
              handleReportPost={handleReportPost}
              handleReportReply={handleReportReply}
            />

          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )

}

const mapStateToProps = (state) => {
  return {
    dsrActionList: state.dsrActionList.results.data,
    userActionRequiredState: state.dsrPopup.UserActionRequired,
    showDsrModalState: state.dsrModal.showDsrModal,
    selectedDisplaySubpage: state.changeDsrPage.selectedDisplaySubpage,
    selectedDisplayPageId: state.changeDsrPage.selectedDisplayPageId,
    currentDsrId: state.dsrFeedContent.id,
    showLoadMoreRedux: state.dsrFeedContent.allowLoadMore,
    dsrPagesRedux: state.setDsrPages.pages,
    dsrPropertiesRedux: state.draftDsrProperties.properties,
    dsrTeamMembersRedux: state.dsrTeamMembers.members,
    dsrUserTeam: state.dsrUserTeam.userTeam,
    createNewDsrFeedPostOutcome: state.createNewDsrFeedPostOutcome.results.data,
    editDsrFeedPostOutcome: state.editDsrFeedPostOutcome.results.data,
    editDsrFeedReplyOutcome: state.editDsrFeedReplyOutcome.results.data,
    isReadingMode: state.isReadingMode.results,
    isMobileView: state.mobileViewMode.isMobileView,
	  overviewPageId: state.overviewPageId.id,
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      editDsrReaction,
      editDsrFeedPost,
      deleteDsrFeedPost,
      deleteDsrReply,
      createNewDsrFeedPost,
      createNewDsrFeedReply,
      editDsrReply,
      loadMoreFeedContentAct,
      replaceDsrFeedContent,
      logGuestDsrAnalytics
    },
    dispatch,
  )

export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(RenderDsrContent)))
